<template>
  <el-dialog
    custom-class="real-dialog"
    title="相机排序"
    :visible="dialogVisible"
    width="500px"
    @close="handleClose"
    center
    append-to-body
  >
    <draggable v-model="gateArray">
      <transition-group name="fade">
        <div v-for="element in gateArray" :key="element.id" class="move">
          {{element.name}}
        </div>
      </transition-group>
    </draggable>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClick">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import draggable from "vuedraggable"
import showdialog from "@/minxs/showdialog";
import { sortParkLotGate } from "@/api/module/park";

export default {
  components: {
    draggable
  },
  props: {
    videoGateId: {
      type: Number,
      default: -1
    },
    selectDisabled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [showdialog],
  data() {
    return {
      gateArray: [],
    };
  },
  computed: {
    gateIds: function () {
      return this.$store.state.order.gateIds ? this.$store.state.order.gateIds : [];
    },
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      if (this.gateIds.length > 0) {
        this.gateArray = this.gateIds.map(v => {
          return {id: v.Id, name: v.Name}
        })
      }
    });
  },
  methods: {
    async handleClick(){
      let arr = this.gateArray.map(v => {
        return v.id
      });
      let res = await sortParkLotGate({
        gateSort: arr,
        sentryBoxId: Number(sessionStorage.getItem("sentryId")),
      });
      if (res.state === "success") {
        this.$store.dispatch("SETGateIdsSortStr", JSON.stringify(arr));
        this.handleClose();
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .move{
    cursor: move;
    line-height: 3;
    color: #000;
    font-size: 14px;
    text-align: center;
    margin-bottom: 10px;
    background: rgba(94, 127, 236, 0.1);
    /*border: 1px solid  #999;*/

  }
</style>
